export type UserToChat = {
  email: string;
  firstName: string;
  id: string;
  lastName: string;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const isUserToChat = (value: unknown): value is UserToChat => {
  if (!isRecord(value)) {
    return false;
  }

  return (
    typeof value.id === 'string' &&
    value.id !== '' &&
    typeof value.email === 'string' &&
    value.email !== '' &&
    typeof value.firstName === 'string' &&
    typeof value.lastName === 'string'
  );
};
